import React from 'react';
import { useAuth } from './../components/AuthProvider'; // Adjust path to your AuthContext file

export default function AdminNavigation({ tabs = [], currentTab = '', onSelectTab = () => {} }) {
  const { user, logout } = useAuth();

  // If auth context isn't fully loaded yet or user is missing, don't crash
  if (!user) return null;

  return (
    <nav className="nav-sidebar-container">
      <div className="admin-sidebar-brand">
        <span className="admin-brand-mark">R</span>
        <span className="admin-brand-copy">
          <strong>RPSWISS</strong>
          <small>ADMIN PORTAL</small>
        </span>
      </div>

      {tabs.length > 0 && (
        <>
          <div className="nav-section-title">Workspace</div>
          <div className="nav-module-list">
            {tabs.map((tab) => (
              <button
                type="button"
                key={tab.id}
                className={`nav-module-button ${currentTab === tab.id ? 'active' : ''}`}
                aria-current={currentTab === tab.id ? 'page' : undefined}
                onClick={() => onSelectTab(tab.id)}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </>
      )}

      <div className="nav-actions">
        <button onClick={logout} className="nav-logout-button">
          {/* Inline SVG Logout icon */}
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: '8px' }}>
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
            <polyline points="16 17 21 12 16 7"></polyline>
            <line x1="21" y1="12" x2="9" y2="12"></line>
          </svg>
          Log Out
        </button>
      </div>
    </nav>
  );
}